<div class="right-margin">
    <button class="close-icon" (click)="closeDialog()"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body form">
    <h2>Contact Us</h2>
    <div>{{info}}</div>
    <div style="width: 100%; margin-top: 10px;">
       <textarea name="message" rows="4" style="line-height: 20px;" [(ngModel)]="message"></textarea>
    </div>
    <div class="block-buttons">
       <button type="button" (click)="confirm()">Send</button>
    </div>
</div>